import { Injectable, inject, signal } from '@angular/core';
import { AuthService } from './auth.service';
import { EventEmitterService } from './event-emitter.service';

/**Service to check signed in user roles */

@Injectable({
    providedIn: 'root',
  })

  export class UserRolesService {
    private userRoles;

    constructor(private appEventsService: EventEmitterService, private _authService: AuthService) {
      //Pulish to the event raised to re get the roles
      this.appEventsService.userSignIn$.subscribe(() => {
          this.userRoles = this._authService.getDecodedAccessRoles();
      });
    }

    getUserRole(role: string){
      if(this.userRoles == null || this.userRoles == undefined)
        this.appEventsService.emitUserSignInEvent();
        
      return  this.userRoles.find((a) => a.Name == role) == undefined ?  false : true;
    }
  }